import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './User.scss'

import { SlideIn } from '../Transitions'

import UserAvatar from './UserAvatar'

const User = ({ name, login, avatar, licence, message, requestUserLogOut }) => (
	<SlideIn from="bottom">
		<div styleName="user">
			{/*<div styleName="message">{user.welcomeMsg}</div>*/}

			<span>
				<div styleName="banner">
					<div styleName="avatar">
						<UserAvatar avatarUrl={'//' + avatar} />
					</div>
					<div styleName="meta">
						<span styleName="name">{name}</span>
						<br />
						<span styleName="login">{login}</span>
						<br />
						<span styleName="licence">Licence: {licence}</span>
					</div>
				</div>

				<a
					href="#"
					styleName="link"
					onClick={e => {
						e.preventDefault()
						requestUserLogOut()
					}}
				>
					<div styleName="label">Log me out</div>
					<i className="material-icons" styleName="icon">
						power_settings_new
					</i>
				</a>
			</span>
		</div>
	</SlideIn>
)

User.propTypes = {
	name: React.PropTypes.string,
	login: React.PropTypes.string,
	avatar: React.PropTypes.string,
	requestUserLogOut: React.PropTypes.func
}

export default CSSModules(User, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/User/User.js